import { Component, ElementRef, ViewChild, Input, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { OACheckboxComponent } from '../../../../common-components/oa-checkbox/oa-checkbox.component';

import { JsonPatchOperation } from '@app/interfaces/json-patch-operation';
import { ICheckboxConfiguration } from '@app/interfaces';

import ValidationResultModel from '@app/models/validation-result-model';
import ListingContactViewModel2 from '@app/models/listing-contact-view-model2';
import LeadStatus from '@app/models/lead-status';

import {
  ListingContactService,
  ErrorHelperService,
  ValueService
} from '@app/services';


@Component({
    selector: 'landowner-postcard',
    imports: [CommonModule, RouterModule, MatIconModule, MatCheckboxModule, NgIf, FormsModule, OACheckboxComponent],
    templateUrl: './landowner-postcard.component.html',
    styleUrls: ['./landowner-postcard.component.css']
})
export class LandownerPostcardComponent implements OnInit {
  private readonly _componentName = 'LandownerPostcardComponent';

  public validating: boolean = false;
  public validationResult: ValidationResultModel;
  public codeFirst4Chars: string = '';
  public codeLast4Chars: string = '';
  
  public contact?: ListingContactViewModel2;
  public ownerName: string;
  private _phoneNumber: string;
  private _emailAddress: string;
  
  private _activities: ICheckboxConfiguration[] = [
    { label: 'Hunting $$$', checked: true, id: 'hunting', title: undefined },
    { label: 'Fishing $$', checked: true, id: 'fishing', title: undefined },
    { label: 'Camping $', checked: true, id: 'camping', title: undefined },
  ];


  @ViewChild("inputCodeLast4Chars", { static: true }) inputCodeLast4Chars: ElementRef;

  @Input() public showNoCodeButton = false;

  constructor(
    private listingContactService: ListingContactService,
    private errorHelper: ErrorHelperService,
    private valueHelper: ValueService,
    private title: Title,
  ) {

    this.validateCode();
  }

  ngOnInit() {
    this.title.setTitle(`Outdoor Access - Postcard`);
    

  }

  public get errorMessage(): string {
    if (this.validationResult && this.validationResult.issues && this.validationResult.issues.length === 1) {
      return this.validationResult.issues[0];
    } else {
      return undefined;
    }
  }

  public get propertyId(): string {
    return `${this.codeFirst4Chars}${this.codeLast4Chars}`;
  }

  public get activities(): ICheckboxConfiguration[] {
    return this._activities;
  }

  public set activities(v: ICheckboxConfiguration[]) {
    this._activities = v;
  }

  public get phoneNumber(): string {
    return this._phoneNumber;
  }

  public set phoneNumber(v: string) {
    this._phoneNumber = v;

    console.log(`${this._componentName}.phoneNumber - set - v=`, v);
  }

  public get emailAddress(): string {
    return this._emailAddress;
  }
  public set emailAddress(v: string) {
    this._emailAddress = v;
    console.log(`${this._componentName}.emailAddress - set - v=`, v);
  }

  public get showContinue(): boolean {
    if (this._emailAddress && this._phoneNumber) {
      return true
    } else {
      return false;
    }
    
  }

  public onCodeChange(id: string, text: string) {
    // Check to see if we need to focus on the last-4 input
    if (id === 'input-codeFirst4Chars') {
      if (text && text.length === 4) {
        this.inputCodeLast4Chars.nativeElement.focus();
      }
    }
    this.validateCode();
  }

  private validateCode() {
    this.validating = true;
    const x = this.propertyId.toLocaleUpperCase();
    if (x.length === 0) {
      this.validationResult = null;
      this.validating = false;
      return;
    }
    if (x.length !== 8) {
      this.validationResult = { isValid: false, issues: ['Incomplete reference code'] };
      this.validating = false;
    } else {
      this.listingContactService.validateDirectMailReferenceCode(x).subscribe(
        (result) => {
          console.log(`${this._componentName} subscription result=`, result);
          this.validationResult = result;
          this.validating = false;
      },
        error => {
          console.error(error);
          let msg = this.errorHelper.getErrorMessage(error) || 'A subscription error occured';
          this.validationResult = { isValid: false, issues: [msg] };
          this.validating = false;
        }
      )
    }
  }

  public onPaste(evt: ClipboardEvent) {
    if (evt && evt.clipboardData && evt.clipboardData.getData('text')) {
      const text = evt.clipboardData.getData('text');

      if (text && text.length === 8) {
        this.codeLast4Chars = text.substring(4, 8);
        this.validateCode();
      }
    }
  }

  public onProceed() {
    // code has been entered and submitted
    this.listingContactService.getByPropertyId(this.propertyId).subscribe(
      result => {
        this.contact = result;
        this.ownerName = result.taxBillOwnerName;
        this.phoneNumber = result.cellphone;
        this.emailAddress = result.emailAddress;
        this.listingContactService.setActiveContact(result);
      }
    )
  }

  public onNoCodeClick() {
    
  }

  public onPhoneNumberConfirmationChange(phone: string) {
    console.log(`${this._componentName}.onPhoneNumberConfirmationChange() phone=${phone}`);
    this._phoneNumber = phone;

    if (!phone || this.valueHelper.isValidPhoneNumber(phone)) {
      let leadStatus = LeadStatus.NeedsFollowUp;

          if (!phone && !this._emailAddress) {
            leadStatus = LeadStatus.NotInterested;
          }

          this.listingContactService
            .patchValuesBySecureId(this.contact.id, this.contact.secureAlternateId, [
              {
                op: 'replace',
                path: 'cellphone',
                value: phone,
              } as JsonPatchOperation,
              {
                op: 'replace',
                path: 'preferredContact',
                value: 'Cell Phone',
              } as JsonPatchOperation,
              {
                op: 'replace',
                path: 'leadStatusId',
                value: leadStatus,
              } as JsonPatchOperation,
            ])
            .subscribe(
              (result) => {
                console.log(`${this._componentName} subscription result=`, result);
              },
              (err) => {
                console.error(err);
                
              }
            );
    }
  }

  public onEmailConfirmationChange(email: string) {
    console.log(`${this._componentName}.onEmailConfirmationChange() phone=${email}`);

    if (!email || this.valueHelper.isValidEmail(email)) {
      let leadStatus = LeadStatus.NeedsFollowUp;

          if (!email && !this._phoneNumber) {
            leadStatus = LeadStatus.NotInterested;
          }

          this.listingContactService
            .patchValuesBySecureId(this.contact.id, this.contact.secureAlternateId, [
              {
                op: 'replace',
                path: 'emailAddress',
                value: email,
              } as JsonPatchOperation,
              {
                op: 'replace',
                path: 'preferredContact',
                value: 'Email',
              } as JsonPatchOperation,
              {
                op: 'replace',
                path: 'leadStatusId',
                value: leadStatus,
              } as JsonPatchOperation,
            ])
            .subscribe(
              (result) => {
                console.log(`${this._componentName} subscription result=`, result);
              },
              (err) => {
                console.error(err);
                
              }
            );

    }
  }

  public onCheckboxStateChange(evt: any, activity: any) {
    console.log(`${this._componentName}.onCheckboxStateChange this.activities:`, this.activities);
    // NOTE: if the activities are bound to the <oa-checkbox>, we don't set the activities checked status

    var data = this.listingContactService.getContactData(this.contact);
    // .forEach   = this.activities;

    data.activities.forEach((element) => {
      element.checked = this.activities.find((a) => a.label === element.name).checked;
    });

    this.listingContactService.updateContactData(this.contact.id, data).subscribe(
      (result) => {
        console.log(`${this._componentName} subscription result=`, result);

        this.contact.data = result.data;
      },
      (err) => {
        console.error(err);
        
      }
    );
  }
}
